// index.ts
import { FetchClient } from "./client.mjs";
import { reviveJson } from "./client.mjs";
import { CRUDL } from "./crudl.mjs";
import { APIError } from "./errors.mjs";
function installExtension(name, Extension) {
  function get() {
    const value = new Extension(this);
    Object.defineProperty(this, name, { value });
    return value;
  }
  Object.defineProperty(FetchClient.prototype, name, { get });
}
function createClient(options = {}) {
  return new FetchClient(options);
}
export {
  APIError,
  CRUDL,
  createClient,
  installExtension,
  reviveJson
};
//# sourceMappingURL=index.mjs.map
